export default __webpack_public_path__ + "static/media/Shillelagh of Sogoth.929d0435.jpg";